import { Control, Controller, FieldValues } from "react-hook-form";
import {
  TextField,
  FormControl,
  Select,
  InputLabel,
  MenuItem,
} from "@mui/material";

export type SelectFieldOption = {
  value: string | number;
  label: string;
};

type Props = {
  name: string;
  control: Control<FieldValues, any>;
  label: string;
  defaultValue?: string | number | null;
  options: SelectFieldOption[];
  onSelect?: Function;
};

const SelectField = ({
  name,
  control,
  label,
  defaultValue,
  options,
  onSelect,
}: Props) => {
  console.log("defaultValue", defaultValue, typeof defaultValue);
  const menuItems = options.map((option: SelectFieldOption, index: number) => (
    <MenuItem value={option.value} key={`option_${index}`}>
      {option.label}
    </MenuItem>
  ));
  const labelId = `${name}-label`;

  return (
    <FormControl>
      <InputLabel id={labelId}>{label}</InputLabel>
      <Controller
        name={name}
        control={control}
        defaultValue={defaultValue}
        render={({ field: { onChange } }) => (
          <Select
            labelId={labelId}
            onChange={(arg) => {
              onChange(arg);
              if (onSelect) {
                onSelect(arg.target.value);
              }
            }}
            label={label}
            defaultValue={defaultValue}
          >
            {menuItems}
          </Select>
        )}
      />
    </FormControl>
  );
};

export default SelectField;
